// Entry point for the app

import './utilities/configureLogger';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './utilities/reportWebVitals';
import { ThemeProvider } from './app/ThemeProvider';
import './styles/tailwind.css';
import { analyticsService } from './services/analyticsService';

// Initialize Google Analytics
analyticsService.initialize();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const RootComponent = () => (
  // <React.StrictMode>
  <ThemeProvider defaultTheme="dark">
    <App />
  </ThemeProvider>
  // </React.StrictMode>
);

root.render(<RootComponent />);

reportWebVitals(console.debug);
